




























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { IAudioFTP } from "@/@types/audio/audio";
import { audio } from "@/config/host.config";
import { AxiosResponse } from "axios";

import ButtonBack from "@/components/buttons/button-back.vue";
import FsDirectorys from "@/components/tables/audio/fs-directorys.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import UploadingMedias from "@/components/app/images/uploading-medias.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    ButtonBack,
    FsDirectorys,
    "submit-button": SubmitResetButtonGroop,
    upload: UploadingMedias,
  },
})
export default class AudioFTPPage extends Vue {
  directorys: Array<IAudioFTP> = [];
  files: Array<IAudioFTP> = [];
  path = "";
  parentPath = "";

  tabIndex = 0;
  uploadShow = false;

  name = "";
  iouri = audio.audio_fs_socket;

  update: IAudioFTP | null = null;

  isPrev(): void {
    console.log("isPrev");

    const paths = this.parentPath.split("/");
    if (!paths) return;
    const path = paths.pop();
    this.path = path ? path : "";
    this.parentPath = paths ? paths.join("/") : "";
  }

  isNext(newpath: string): void {
    this.parentPath += this.path;
    this.path = newpath;
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  updateFile(file: IAudioFTP): void {
    this.update = file;
    this.$bvModal.show("bv-modal-add");
    this.name = file.name.split(".").slice(0, -1).join(".");
  }

  async deleteFile(path: string): Promise<void> {
    const uri = audio.audio_fs;
    const params = { path };
    try {
      const res = await this.$axios.delete(uri, { params });
      if (res.status === 200) {
        this.getAudioFS();
        return;
      }
      this.onError();
    } catch (e) {
      console.log(e);
      this.onError();
    }
  }

  @Watch("path")
  updatePath(): void {
    this.getAudioFS();
  }

  @Watch("tabIndex")
  showAudioForm(): void {
    if (this.tabIndex == 1) this.uploadShow = true;
    else this.uploadShow = false;
  }

  async getAudioFS(): Promise<void> {
    const uri = audio.audio_fs;
    const params = { path: this.path };

    try {
      const result: AxiosResponse<Array<IAudioFTP>> = await this.$axios.get(
        uri,
        {
          params,
        }
      );
      if (result.status === 200) {
        this.files = [];
        this.directorys = [];
        result.data.map((el) => {
          if (el.type == "file") this.files.push(el);
          if (el.type == "directory") this.directorys.push(el);
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async onSubmit(event: HTMLFormElement): Promise<void> {
    event.preventDefault();
    if (!this.name) this.name = "new";
    try {
      const uri = audio.audio_fs;
      const method = this.update ? "put" : "post";
      const path = this.update ? this.update.path : `${this.path}/${this.name}`;

      if (
        this.update &&
        this.update.name.split(".").slice(0, -1).join(".") == this.name
      )
        return;

      const data = this.update
        ? {
            newname:
              this.name + "." + this.update?.name.split(".").slice(-1)[0],
          }
        : {};

      const res = await this.$axios[method](uri, data, { params: { path } });
      if (res.status === 200) {
        this.$bvModal.hide("bv-modal-add");
        if (this.update) {
          const arr = this.update.type == "file" ? this.files : this.directorys;
          const i = arr.findIndex((el) => el.path == this.update?.path);
          if (i < 0) {
            this.getAudioFS();
            return;
          }
          this.$set(arr[i], "name", this.name);
          this.$set(arr[i], "path", path);
        } else {
          this.getAudioFS();
        }
        this.clear();
        return;
      }
      this.onError();
    } catch (e) {
      console.log(e);
      this.onError();
    }
  }

  clear(): void {
    this.update = null;
    this.name = "";
    this.uploadShow = false;
    this.$nextTick(() => (this.uploadShow = true));
  }

  mounted(): void {
    this.getAudioFS();
  }
}
